import { render, staticRenderFns } from "./NTK.vue?vue&type=template&id=0349552c"
import script from "./NTK.vue?vue&type=script&lang=js"
export * from "./NTK.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports